<template>
  <div class="input-cell">
    <p v-if="title" class="input-cell-title">{{ title }}</p>
    <input
      class="input-cell-input ios-no-zoom"
      :disabled="!isInputable"
      :type="inputType"
      :placeholder="placeholder"
      v-model="value"
      @input="onInput"
      @blur="onBlur"
    />
    <slot name="right" class="input-slot"></slot>
    <div class="input-cell-click" v-if="!isInputable" @click="onCellClick"></div>
  </div>
</template>

<script>
import { resetViewportScroll } from '@/utils/viewport'

export default {
  props: {
    title: String,

    initialValue: {
      type: String,
      default: ''
    },

    // 可以输入内容也可以是点击选择
    isInputable: {
      type: Boolean,
      default: true
    },

    inputType: {
      type: String,
      default: 'text'
    },

    placeholder: {
      type: String,
      default: '请输入'
    }
  },

  data: function () {
    return {
      value: ''
    }
  },

  created () {
    this.value = this.initialValue
  },

  watch: {
    initialValue(value) {
      this.value = value
    }
  },

  methods: {
    onInput(e) {
      this.$emit('onInput', this.value)
    },

    onBlur () {
      // 解决H5页面在微信中打开，input输入框获取焦点时，页面被软键盘顶上去；关闭软键盘时，页面不会自动下来（恢复初始状态）
      resetViewportScroll()
    },
    onCellInputClick(){
      // this.$emit('onCellInputClick')
      console.log("cellclick");
    },
    onCellClick () {
      if (!this.isInputable) {
        this.$emit('onCellClick')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.input-cell {
  background-color: white;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding-left: 18px;
  padding-right: 18px;
  display: flex;
  align-items: center;
  margin-top: 24px;
  position: relative;

  &-title {
    color: #c8c9cc;
    font-size: 14px;
    width: 74px;
    box-sizing: border-box;
    padding-left: 16px;
  }

  &-click{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 44px;
  }
  input {
    color: #323233;
    font-size: 14px;
    border: none;
    outline: none;
    flex: 1;
    margin-left: 16px;
  }

  input[disabled],
  input:disabled,
  input.disabled {
    background-color: white;
  }

  input::-webkit-input-placeholder {
    color: #c8c9cc;
    font-size: 14px;
  }

  input.ios-no-zoom,
  input.ios-no-zoom::-webkit-input-placeholder {
    font-size: 16px;
  }
}
</style>
